import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * transformUpdateMopPayload transforms update mop payload billing address
 */
export var transformUpdateMopPayload = function transformUpdateMopPayload(payload, state) {
  var nonce = payload.nonce,
    details = payload.details,
    name = payload.name,
    billing = payload.billing,
    accountType = payload.accountType,
    deviceData = payload.deviceData;
  var mopOnFile = state.mopOnFile;
  var selectedMop = mopOnFile.selectedMop;
  var expirationMonth = details.expirationMonth,
    expirationYear = details.expirationYear,
    payerId = details.payerId;

  // NOTE: fname, lname, and zip are required fields!!
  var _name$split = name.split(' '),
    _name$split2 = _slicedToArray(_name$split, 2),
    fname = _name$split2[0],
    lname = _name$split2[1];
  var billingData = {};
  var city = billing.city,
    billingState = billing.state,
    zip = billing.zip,
    country = billing.country;
  billingData = {
    fname: fname,
    lname: lname,
    line1: '',
    line2: '',
    city: city,
    state: billingState,
    zip: zip,
    country: country //NOTE: CHEGG REQUIRES COUNTRY AS 2-CHAR COUNTRY CODE, NOT FULL COUNTRY NAME!
  };

  return _objectSpread(_objectSpread({
    cardId: selectedMop.cardId,
    nonce: nonce,
    billing: billingData,
    name: name,
    deviceData: deviceData,
    month: expirationMonth,
    year: expirationYear
  }, accountType ? {
    accountType: accountType
  } : {}), payerId ? {
    payerId: payerId
  } : {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/transformUpdateMopPayload.js
// module id = 4397
// module chunks = 11